import { connect } from 'react-redux';
import { PlansSelector } from '../../redux/reducers/PlansReducer';
import Order from '../../components/payment/Order/Order';
import { ConfigSelector } from '../reducers/ConfigReducer';

const mapStateToProps = state => ({
  isContractSelected: PlansSelector.getIsContractSelected(state),
  validatedPromoCode: state.payment.validatedPromoCode,
  modemPrice: PlansSelector.getModemPrice(state),
  connectionPrice: PlansSelector.getConnectionPrice(state),
  shippingPrice: PlansSelector.getShippingPrice(state),
  offer: ConfigSelector.getGiftWithPurchase(state),
  discount: ConfigSelector.getDiscount(state),
  subscriptionDiscount: ConfigSelector.getDiscountWithSubscription(state),
  isByoModemSelected: PlansSelector.getIsByoModemSelected(state),
});

const OrderContainer = connect(mapStateToProps)(Order);

export default OrderContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/OrderContainer.js
 **/